import { FETCH_GUIDE } from './constants'

const initialState = {
  isFetching: true,
  guide: {}
}

export default function guideReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_GUIDE.REQUEST: {
      return {
        ...state,
        isFetching: true
      }
    }

    case FETCH_GUIDE.SUCCESS: {
      return {
        ...state,
        isFetching: false,
        guide: action.guide
      }
    }

    default: {
      return state
    }
  }
}
